import React, { useState } from "react";
import { CreditCard, ArrowLeftRight } from "lucide-react";

// IMPORT BOTH COMPONENTS
import Ccbp from "./Ccbp";
// import CCBPNew from "./CCBPNew";

const CCBPDashboard = () => {
  // const [activeTab, setActiveTab] = useState("modern");

  // const tabs = [
  //   {
  //     id: "modern",
  //     title: "Direct Pay",
  //     icon: CreditCard,
  //   },
  //   {
  //     id: "classic",
  //     title: "Fetch and Pay",
  //     icon: ArrowLeftRight,
  //   },
  // ];

  return (
    <div className="p-4 md:p-6">
      {/* TOP TAB SECTION */}

      {/* <div className="max-w-7xl mx-auto mb-6">
        <div className="p-4 rounded-[32px]">
          <div className="grid grid-cols-2 rounded-[28px] overflow-hidden shadow-lg bg-white">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              const active = activeTab === tab.id;

              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`
                    flex items-center justify-center gap-3
                    py-6 px-4
                    text-lg md:text-2xl
                    font-bold
                    transition-all duration-300
                    ${
                      active
                        ? "bg-[#12345A] text-white"
                        : "bg-white text-[#4B5563]"
                    }
                  `}
                >
                  <Icon size={26} />
                  <span>{tab.title}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div> */}

      {/* HEADING */}
      <div className="max-w-7xl mx-auto mb-6">
        <div className="p-4 rounded-[32px]">
          <div className="rounded-[28px] overflow-hidden shadow-lg bg-white">
            <div className="flex items-center justify-center gap-3 py-6 px-4 bg-[#12345A]">
              <ArrowLeftRight size={26} className="text-white" />
              <span className="text-lg md:text-2xl font-bold text-white">
                Fetch and Pay
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* CONTENT */}

      <div className="max-w-7xl mx-auto">
        <div className="rounded-[28px] overflow-hidden">
          {/* {activeTab === "modern" ? <CCBPNew /> : <Ccbp />} */}
          <Ccbp />
        </div>
      </div>
    </div>
  );
};

export default CCBPDashboard;
